module.exports = __webpack_public_path__ + "static/media/10.c68e12be.png";